document.addEventListener('alpine:init', () => {
  Alpine.data('accordionItem', () => ({
    scrollHeight: 0,
    debounceTimeout: null,

    init() {
      this.$nextTick(() => this.ready());
    },

    ready() {
      this.calcScrollHeight();
    },

    calcScrollHeight() {
      clearTimeout(this.debounceTimeout);

      this.debounceTimeout = setTimeout(() => {
        this.$refs.innerBlocks.style.transition = 'none';
        this.$refs.innerBlocks.style.height = 0;
        const padding = window.innerWidth < 768 ? 32 : 24;
        this.$refs.innerBlocks.style.height = this.$refs.innerBlocks.scrollHeight + padding + 'px';

        setTimeout(() => {
          this.$refs.innerBlocks.style.transition = null;
        }, 150);
      }, 500);
    },
  }));
});